// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"203":"c8913072","308":"c8cad5b6","554":"c949f2a8"}[chunkId] + ".js";
};